module.exports = __webpack_public_path__ + "img/test04-2.9c37e378.jpg";